import { Injectable } from '@angular/core';
import { AppPathsModel, AppPaths, ControllerPathsModel } from 'projects/cross-study-portal-lib/src/public-api';

@Injectable({
  providedIn: 'root',
})
export class CrossStudyPortalAppPathsService implements AppPaths {
  getAppPaths(): AppPathsModel {
    return {
      appConfigPath: '/app-config.json',
    };
  }

  getControllerPaths(): ControllerPathsModel {
    return {
      contextApiPath: '/api/context',
      timeoutApiPath: '/api/timeout',
      sitesApiPath: '/api/sites',
      authorizationApiPath: '/api/authorization',
      userManagement: '/api/usermanagement',
      userApiPath: '/api/users',
      studyApiPath: '/api/Study',
      userFilterApiPath: '/api/UserFilterOptions',
      configurationApiPath: '/api/Configuration',
      userStudyMembershipApiPath: '/api/user-study-membership',
    };
  }
}
